import TokenEditorModal from "./TokenEditorModal";
import { connect, useDispatch } from "react-redux";
import { RootState } from "store/store";
import SubscriptionTokenResponse from "interfaces/response/SubscriptionTokenResponse";
import Button from "components/common/controls/Button";
import LinkButton from "components/common/LinkButton";
import Checkbox from "components/common/controls/Checkbox";
import { useState } from "react";
import { copyTextToClipboard } from "shared/utility/CommonUtility";
import { EditorMode } from "shared/enums/EditorModeEnum";
import { toastSuccess } from "components/common/ToastNotification";
import { resetKeyOfSelectedToken } from "store/slices/TokenSlice";

interface Props {
  createdToken?: SubscriptionTokenResponse | null;
  onClose?: () => void;
  mode?: EditorMode;
}

export function CreateOrUpdateTokenSuccessPopup(props: Props) {
  const { createdToken, mode, onClose } = props;
  const [isConfirmed, setIsConfirmed] = useState(false);
  const isInEditingMode = mode === EditorMode.Edit;
  const dispatch = useDispatch();

  const handleCheckedChange = (event: any) => {
    setIsConfirmed(event.value);
  };

  const handleOnClose = () => {
    dispatch(resetKeyOfSelectedToken());
    onClose?.();
  };

  const ConfirmationCheckboxLabel = () => {
    return (
      <span>
        I am aware that this token key{" "}
        <span className="font-bold">will not be accessible </span> again and
        have stored a copy of it in in a secure location.
      </span>
    );
  };

  const copyKey = () => {
    copyTextToClipboard(createdToken?.key || "");
    toastSuccess("Key copied to clipboard.");
  };

  return (
    <div>
      <TokenEditorModal
        title={`${isInEditingMode ? "Regenerated Key" : "Token Created"}`}
        onClose={() => handleOnClose?.()}
      >
        <div>
          <span>
            <div>
              Your token{" "}
              {`${
                isInEditingMode
                  ? "key has been regenerated"
                  : "has been created"
              }`}
              . Here is its corresponding key.
            </div>
            <span className="font-bold text-primaryRed clearfix">
              This key will only be displayed once!{" "}
            </span>
            Make sure to note down the token name and key in a secure location.
            Do not share this key with unauthorised persons.
          </span>

          <div className="border-1.5 border-silver rounded-lg p-5 mt-5">
            <div>
              <span className="font-bold">name</span>: {createdToken?.name}
            </div>
            <div className="mt-3 break-all">
              <span className="font-bold">key</span>: {createdToken?.key}
              <LinkButton className="ml-2 text-primaryRed" onClick={copyKey}>
                copy
              </LinkButton>
            </div>
          </div>

          <div className="mt-5">
            <Checkbox
              labelComponent={<ConfirmationCheckboxLabel />}
              onValueChanged={handleCheckedChange}
            />
          </div>

          <div className="mt-6 float-right">
            <Button
              text="Close"
              onClick={handleOnClose}
              disabled={!isConfirmed}
            />
          </div>
        </div>
      </TokenEditorModal>
    </div>
  );
}

const mapStateToProps = (state: RootState, props: Props) => {
  const createdToken = state.tokenData.selectedToken;
  return {
    ...props,
    createdToken,
  };
};

export default connect(mapStateToProps)(CreateOrUpdateTokenSuccessPopup);
